let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eILt2")).then(() => parcelRequire('kiGd7'));